import 'globals/polyfills.js';
import 'lib/vendor_extensions/jquery_extended.js';
import 'lib/vendor_extensions/select2_extended.js';
import "magnific-popup"
import "colcade/colcade.js"
import 'lib/contently.js';
import 'lib/contently.ui.behaviors.js';
import 'lib/contently.ui.js.coffee';
import 'lib/toolkit/toolkit.js.coffee';
import 'nested-form';
import 's3_direct_upload';



// WEBPACK FOOTER //
// ./app/javascript/globals/outside.js